const EXAMPLE_DECIMAL = 1.1;

export function formatCurrency(value: number, locale: string, options: Intl.NumberFormatOptions): string {
    return new Intl.NumberFormat(locale, { style: 'currency', ...options }).format(value);
}

export const delimiter
    = Intl.NumberFormat(navigator.language)
        .formatToParts(EXAMPLE_DECIMAL)
        .find(part => part.type === 'decimal')
        ?.value ?? '.';

export const thousandSeparator = delimiter === '.' ? ',' : '.';
